import "./finalCta.css";

const SIGNUP_URL = "https://app.raincareers.com/auth?mode=signUp";

/* Same closing shape as the rest of the site: one light panel, centred, with
   a single pill. The navy split-band this replaced was the only section of
   its kind on any page. */
const FinalCta = () => (
  <section className="s-final-section">
    <div className="home-container">
      <div className="s-final">
        <h2 className="s-final-title">
          Your next opportunity starts{" "}
          <br className="br-wide" />
          with one clear step.
        </h2>

        <a className="s-final-btn" href={SIGNUP_URL}>
          Start your search
        </a>

        {/* Free to start is true for everyone, not only partner schools —
            see the free plan on /pricing. */}
        <p className="s-final-note">
          Create your account in minutes. Free to start, and fully covered at
          partner schools.
        </p>
      </div>
    </div>
  </section>
);

export default FinalCta;
